import React from "react";

import {
  NavBar,
  Footer,
  Landing,
  About,
  Skills,
  Experience,
  Contact,
  Projects,
} from "../../components";

const Main = () => {
  return (
    <div>
      <NavBar />
      <Landing />
      <About />
      <Skills />
      <Projects />
      <Experience />
      <Contact />
      <Footer />
    </div>
  );
};

export default Main;
